export const EVENTS = {
  OPT_IN_SUCCESSFUL: "Promo Opt In Successful",
  OPT_IN_FAILED: "Promo Opt In Failed"
};
